/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateMcpServerRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createMcpServerRequest: components.CreateMcpServerRequest;
};

/** @internal */
export const CreateMcpServerRequest$inboundSchema: z.ZodType<
  CreateMcpServerRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateMcpServerRequest: components.CreateMcpServerRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateMcpServerRequest": "createMcpServerRequest",
  });
});
/** @internal */
export type CreateMcpServerRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateMcpServerRequest: components.CreateMcpServerRequest$Outbound;
};

/** @internal */
export const CreateMcpServerRequest$outboundSchema: z.ZodType<
  CreateMcpServerRequest$Outbound,
  z.ZodTypeDef,
  CreateMcpServerRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createMcpServerRequest: components.CreateMcpServerRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createMcpServerRequest: "CreateMcpServerRequest",
  });
});

export function createMcpServerRequestToJSON(
  createMcpServerRequest: CreateMcpServerRequest,
): string {
  return JSON.stringify(
    CreateMcpServerRequest$outboundSchema.parse(createMcpServerRequest),
  );
}
export function createMcpServerRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateMcpServerRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateMcpServerRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateMcpServerRequest' from JSON`,
  );
}
